module.exports = __webpack_public_path__ + "img/og-sns-common.c94eb7b6.png";